var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / DE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-22.5%",
    width: "110.7%",
    height: "145.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-22.5%",
    width: "110.7%",
    height: "145.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-DE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#F01515",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFD521",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.b62c4774a5855dbf2e3dbbb5f8c649ca.svg";
export { ForwardRef as ReactComponent };